// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { fetchReportMenu, setCurrentReportIndex, setCurrentReportTypeIndex, setReportMenuFetchFailure, setReportMenuFetchSuccess, } from './report-menu.actions';
import { resetAllCustomPdfReportItems } from '../actions';
export const reportMenuFetchRequest = createReducer({ status: null, fetching: false, error: null }, on(fetchReportMenu, (state) => {
    return { ...state, fetching: true, error: null };
}), on(setReportMenuFetchSuccess, (state) => {
    return { ...state, fetching: false, error: null };
}), on(setReportMenuFetchFailure, (state, action) => {
    return { ...state, fetching: false, error: action.error };
}), on(resetAllCustomPdfReportItems, (state) => {
    return { ...state, fetching: false, error: null };
}));
export const customPdfReportMenu = createReducer([], on(setReportMenuFetchSuccess, (state, action) => {
    if (action.data === undefined) {
        return [];
    }
    return action.data;
}), on(setReportMenuFetchFailure, () => {
    return [];
}));
export const currentReportTypeIndex = createReducer(0, on(setCurrentReportTypeIndex, (state, { index }) => {
    return index;
}), on(resetAllCustomPdfReportItems, () => {
    return 0;
}));
export const currentReportIndex = createReducer(0, on(setCurrentReportIndex, (state, action) => {
    return action.index;
}), on(resetAllCustomPdfReportItems, () => {
    return null;
}));
